<template>
	<div class="row">
		<div class="col-xs-12">
			<flCabecalhoForm
				:msg="_traducao('global', 'obrigatorio')"
				cls="print-titulo-form-20"
				:texto="_traducao('global', 'controleHorasOvn')"
			/>
		</div>
		<div class="container-fluid conteudo">
			<div class="row">
				<div class="col-xs-3">
					<label>
						{{ _traducao('global', 'horasVooUsuarioOvn') }}:
						<i
							class="fa fa-info-circle"
							v-tooltip="_traducao('global', 'infoHorasOvn')"
						>
						</i>
					</label>
					<br>
					<input
						type="number"
						v-model.number="form.horas_inicial_ovn"
						min="0"
						max="999"
						placeholder="Horas"
						class="time-input"
						style="width: 48%"
						:disabled="form.existe_diario"
						@blur="formatHours"
					/>
					<span style="width: 2%"> : </span>
					<input
						type="number"
						v-model="form.minutos_inicial_ovn"
						min="0"
						max="59"
						placeholder="Minutos"
						class="time-input"
						style="width: 48%"
						:disabled="form.existe_diario"
						@blur="formatMinutes"
					/>
				</div>
				<div class="col-xs-3">
					<label>{{ _traducao('global', 'dataUltimoVoo') }}:</label>
					<flDateTime
						@v-model="
							(val) => {
								form.data_ultimo_voo_ovn = val
							}
						"
						:value="form.data_ultimo_voo_ovn"
						:format="_formatDate"
						:lang="_getLangDp"
					/>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
  export default {
    data() {
      return {
        form: {
            horas_inicial_ovn: '',
            minutos_inicial_ovn: '',
            data_ultimo_voo_ovn: '',
        }
      }
    },
    methods: {
      editar(item) {
        this.form.horas_inicial_ovn =  item.horas_inicial_ovn
        this.form.minutos_inicial_ovn = item.minutos_inicial_ovn
				this.formatHours()
				this.formatMinutes()
        this.form.data_ultimo_voo_ovn = item.data_ultimo_voo_ovn
      },

      validaForm() {
          this.$emit('dados-ovn', this.form)
      },
			formatHours() {
				if (this.form.horas_inicial_ovn !== '') {
					this.form.horas_inicial_ovn = String(this.form.horas_inicial_ovn).padStart(2, '0');
				}
			},
			formatMinutes() {
				if (this.form.minutos_inicial_ovn !== '') {
					this.form.minutos_inicial_ovn = String(this.form.minutos_inicial_ovn).padStart(2, '0');
				}
			},
    },
    watch: {
      'form.minutos_inicial_ovn'(newValue) {
        if (newValue > 59) {
          this.form.minutos_inicial_ovn = 59;
        } else if (newValue < 0) {
          this.form.minutos_inicial_ovn = 0;
        }
      },
    }
  }
</script>